let toastsStore = null

export const registerToastStore = (store) => {
  toastsStore = store
}

const runToast = (method, options = {}) => {
  if (!toastsStore || typeof toastsStore[method] !== 'function') {
    return null
  }

  return toastsStore[method](options)
}

export const toast = {
  show(options = {}) {
    return runToast('show', options)
  },
  success(options = {}) {
    return runToast('success', options)
  },
  error(options = {}) {
    return runToast('error', options)
  },
  warning(options = {}) {
    return runToast('warning', options)
  },
  info(options = {}) {
    return runToast('info', options)
  },
  action(options = {}) {
    return runToast('action', options)
  },
  remove(id) {
    if (!toastsStore) {
      return
    }

    toastsStore.remove(id)
  },
  clear() {
    if (!toastsStore) {
      return
    }

    toastsStore.clear()
  },
}
